import React from "react";

interface ProfileHeaderMenuIconProps {
  className?: string;
}

function ProfileHeaderMenuIcon({ className }: ProfileHeaderMenuIconProps) {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M30 28H2.00001C0.895397 28 0 27.1046 0 26C0 24.8955 0.895397 24 2.00001 24H30.0001C31.1046 24 32.0001 24.8955 32.0001 26C32 27.1046 31.1046 28 30 28Z"
        fill="#596970"
      />
      <path
        d="M30 18H2.00001C0.895397 18 0 17.1046 0 16C0 14.8955 0.895397 14 2.00001 14H30.0001C31.1046 14 32.0001 14.8954 32.0001 16C32.0001 17.1046 31.1046 18 30 18Z"
        fill="#596970"
      />
      <path
        d="M30 8.00003H2.00001C0.895397 8.00003 0 7.10463 0 6.00001C0 4.8954 0.895397 4 2.00001 4H30.0001C31.1046 4 32.0001 4.8954 32.0001 6.00001C32.0001 7.10463 31.1046 8.00003 30 8.00003Z"
        fill="#596970"
      />
    </svg>
  );
}

export default ProfileHeaderMenuIcon;
